import { Check, ShieldCheck, ArrowRight, ExternalLink } from "lucide-react";
import { Container } from "../components/ui";
import { useLocale } from "../i18n/useLocale";

export default function FreeTrial() {
  const { market, t } = useLocale();
  const included = [
    t("freeTrial:included.1"),
    t("freeTrial:included.2"),
    t("freeTrial:included.3"),
    t("freeTrial:included.4"),
  ];
  return (
    <section className="bg-bg-subtle">
      <Container className="grid gap-12 py-16 md:grid-cols-2 md:py-24">
        <div className="flex flex-col gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-success-soft px-3 py-1 text-[12px] font-semibold text-success">
              <ShieldCheck size={14} strokeWidth={2} /> {t("freeTrial:badge")}
            </span>
          </div>
          <h1 className="font-display text-4xl font-semibold leading-[1.08] tracking-tight text-ink md:text-[48px]">
            {t("freeTrial:hero.title")}
          </h1>
          <p className="max-w-md text-[17px] leading-relaxed text-ink-soft">
            {market === "belgium"
              ? t("freeTrial:hero.lead.be")
              : t("freeTrial:hero.lead.intl")}
          </p>
          <ul className="mt-2 flex flex-col gap-3">
            {included.map((i) => (
              <li key={i} className="flex items-center gap-3 text-[15px] text-ink">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-success-soft text-success">
                  <Check size={14} strokeWidth={2.6} />
                </span>
                {i}
              </li>
            ))}
          </ul>
        </div>

        {/* Placeholder — handoff to the real Done-it sign-up flow */}
        <div className="flex flex-col items-center justify-center rounded-3xl border-2 border-dashed border-line-strong bg-white p-10 text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-soft text-primary">
            <ArrowRight size={26} strokeWidth={2} />
          </span>
          <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-ink">
            {t("freeTrial:placeholder.title")}
          </h3>
          <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-ink-soft">
            {t("freeTrial:placeholder.body")}
          </p>
          <div className="mt-7 inline-flex items-center gap-2 rounded-xl bg-primary px-6 py-3.5 font-display text-[15px] font-semibold text-white opacity-90">
            {t("freeTrial:placeholder.cta")} <ExternalLink size={16} strokeWidth={2} />
          </div>
          <p className="mt-4 text-[12px] font-medium uppercase tracking-wider text-ink-faint">
            {t("freeTrial:placeholder.target")}
          </p>
        </div>
      </Container>
    </section>
  );
}

